import React, { useState, useEffect } from 'react';
import { Container, Paper, Typography, Grid, Button } from '@mui/material';
import { Service } from '../../types';
import { getServices } from '../../services/api';

interface ServiceBookingProps {
  barberId: number;
}

const ServiceBooking: React.FC<ServiceBookingProps> = ({ barberId }) => {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await getServices();
        setServices(data);
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return <Typography>Loading services...</Typography>;
  }

  return (
    <Container>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {services.map((service) => (
          <Grid item xs={12} sm={6} md={4} key={service.id}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6">{service.name}</Typography>
              <Typography variant="body2">{service.description}</Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                Duration: {service.duration} minutes
              </Typography>
              <Typography variant="h6" sx={{ mt: 1 }}>
                ${service.price}
              </Typography>
              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => {
                  // TODO: Implement booking flow
                }}
              >
                Book Now
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ServiceBooking; 